import { Box, Card } from "@mui/material";
import { useEffect, useState } from "react";
import HeaderSection from "../HeaderSection/HeaderSection";
import TabContent from "../TabContent/TabContetn";
import TemplatesBlock from "../TemplatesBlock/TemplatesBlock";

const CrossProductsPage = () => {
  const getStoredTab = () => {
    if (typeof window === "undefined") return 0;
    const saved = window.sessionStorage.getItem("scriptsTabIndex");
    const parsed = Number(saved);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const [tabIndex, setTabIndex] = useState(() => getStoredTab());

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("scriptsTabIndex", String(newValue));
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const saved = window.sessionStorage.getItem("scriptsScrollY");
    const parsed = Number(saved);
    if (Number.isFinite(parsed) && parsed > 0) {
      requestAnimationFrame(() => {
        window.scrollTo(0, parsed);
      });
    }

    const handleScroll = () => {
      window.sessionStorage.setItem(
        "scriptsScrollY",
        String(window.scrollY || window.pageYOffset || 0)
      );
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      handleScroll();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      elevation={3}
      sx={{
        p: { xs: 2, md: 4 },
        borderRadius: 3,
      }}
    >
      <HeaderSection tabIndex={tabIndex} handleTabChange={handleTabChange} />
      <TabContent tabIndex={tabIndex} />
      <TemplatesBlock />
    </Box>
  );
};

export default CrossProductsPage;
